module.exports = __webpack_public_path__ + "static/media/14-3.8f83a512.mp3";